import { AboveBelowFieldsContentType } from 'common.types'
import { useTranslation } from 'react-i18next'

export const VoterRegBelowFieldsContent: React.FC<
  AboveBelowFieldsContentType
> = ({ step, isReviewing, formComplete }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.belowFieldsContent`,
  })

  return (
    <div style={{ fontSize: 12, marginTop: 30 }}>
      {!formComplete && (
        <p dangerouslySetInnerHTML={{ __html: t(`disclosureTwo`) }}></p>
      )}
      <p dangerouslySetInnerHTML={{ __html: t(`disclosureFour`) }}></p>
      {step === 6 && (
        <p dangerouslySetInnerHTML={{ __html: t(`disclosureSeven`) }} />
      )}
    </div>
  )
}
